import React, { useState } from "react";
import Levels from "../Components/Levels";
import SettingsMenu from "../Components/SettingsMenu";
import { RiArrowRightSLine, RiSettings4Fill } from "react-icons/ri";
import { useUser } from "../context/userContext";
import Animate from "../Components/Animate";
import SlotMachine from "../Components/Slot";

const GoldHand = () => {
  const { userLevelss, tapBalance, fullName, balance, refBonus, username } =
    useUser();
  const [showLevel, setShowLevel] = useState(false);
  const [showSetting, setShowSetting] = useState(false);

  const initialLevelIndex = userLevelss.findIndex(
    (level) => tapBalance < level.tapBalanceRequired
  );
  const currentLevelIndex =
    initialLevelIndex === -1 ? userLevelss.length - 1 : initialLevelIndex;

  const displayedLevelIndex = currentLevelIndex;
  const currentLevel = userLevelss[displayedLevelIndex];

  const formatNumber = (num) => {
    if (num < 100000) {
      return new Intl.NumberFormat().format(num).replace(/,/g, " ");
    } else if (num < 1000000) {
      return new Intl.NumberFormat().format(num).replace(/,/g, " ");
    } else {
      return (num / 1000000).toFixed(3).replace(".", ".") + " M";
    }
  };

  return (
    <Animate>
      <div className="w-full flex justify-center flex-col">
        <div className="w-full flex items-center justify-between h-[55px] px-4 bg-[#000]  border-b border-b-[2px] border-b-[#a71414]">
          <div className="w-[50%] flex items-center space-x-[6px]">
            <div
              className={`w-[30px] h-[30px] rounded-[8px] p-[2px] overflow-hidden flex items-center justify-center relative`}
            >
              <img
                src={currentLevel.icon}
                className={`w-[30px] mt-[6px]`}
                alt={fullName || "user"}
              />
            </div>

            <div className="w-[70%] flex flex-col space-y-1 pr-4">
              <div className="w-full flex justify-between text-[10px] font-medium items-center">
                <span className="levelName flex items-center">
                  <span onClick={() => setShowLevel(true)} className="">
                    {currentLevel.name}
                  </span>
                  <span className="flex items-center">
                    {" "}
                    <RiArrowRightSLine size={12} className="mt-[1px]" />{" "}
                  </span>
                </span>

                <span className="">Cheesy {username}</span>
              </div>

              <div className="flex w-full mt-2 items-center bg-[#56565630] rounded-[10px] border-[1px] border-[#49494952]">
                <div
                  className={`h-[6px] rounded-[8px] levelbar`}
                  style={{
                    width: `${
                      (tapBalance / currentLevel.tapBalanceRequired) * 100
                    }%`,
                  }}
                />
              </div>
            </div>
          </div>

          <div className="flex w-[50%] mb-[-4px] rounded-full items-center justify-end">
            <div className="flex flex-col items-center justify-center">
              <p className="text-[9px]">Balance</p>
              <div className="flex items-center justify-center space-x-1 text-[11px]">
                <span className="flex items-center justify-center">
                  <img src="/coin.webp" alt="ppf" className="w-[10px]" />
                </span>
                <span className="font-bold">
                  {formatNumber(balance + refBonus)}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div
          id="refer"
          className="w-full flex flex-col scroller h-[100vh] overflow-y-auto pb-[280px] pt-3 px-4"
        >
          <div className="w-full flex flex-col space-y-3 items-center justify-center">
            <SlotMachine />
          </div>
        </div>

        <Levels showLevel={showLevel} setShowLevel={setShowLevel} />

        <SettingsMenu
          showSetting={showSetting}
          setShowSetting={setShowSetting}
        />
      </div>
    </Animate>
  );
};

export default GoldHand;
